import bareos from "../../ui/img/marketplace-icons/bareos.png";
import clavisternetwall from "../../ui/img/marketplace-icons/clavisternetwall.png";
import gitlab from "../../ui/img/marketplace-icons/gitlab.png";
import grafana from "../../ui/img/marketplace-icons/grafana.png";
import harbor from "../../ui/img/marketplace-icons/harbor.png";
import keycloak from "../../ui/img/marketplace-icons/keycloak.png";
import matomo from "../../ui/img/marketplace-icons/matomo.png";
import mattermost from "../../ui/img/marketplace-icons/mattermost.png";
import mysql from "../../ui/img/marketplace-icons/mysql.png";
import postgresql from "../../ui/img/marketplace-icons/postgresql.png";
import prometheus from "../../ui/img/marketplace-icons/prometheus.png";
import taiga from "../../ui/img/marketplace-icons/taiga.png";
import wordpress from "../../ui/img/marketplace-icons/wordpress.png";

const MarketplaceLogo: Record<string, string> = {
  bareos,
  clavisternetwall,
  gitlab,
  grafana,
  harbor,
  keycloak,
  matomo,
  mattermost,
  mysql,
  postgresql,
  prometheus,
  taiga,
  wordpress,
};

export default MarketplaceLogo;
